export const initialVitals = {
  temperature: "103.2 °F",
  pulse: "128 bpm",
  respiration: "32 rpm",
  pain: "8/24",
  weight: "3.8 kg",
  mentation: "Dull",
  hydration: "Mild dehydration (~5%)",
  asOfTime: "as of 06:00 am",
};

export const initialIOEntries = [
  {
    id: 1,
    time: "07:15 am",
    category: "VOMITING",
    description: "1 episode, bilious",
    loggedBy: "Logged by Nursing staff",
    badgeType: "warning",
    type: "Output",
  },
  {
    id: 2,
    time: "06:00 am",
    category: "IV FLUID",
    description: "LRS — running at 40 ml/hr, 320 ml infused since start",
    loggedBy: "Logged by Nursing staff",
    badgeType: "info",
    type: "Intake",
  },
  {
    id: 3,
    time: "06:00 am",
    category: "IV CATHETER / SITE CHECK",
    description: "Left cephalic — patent, no swelling or phlebitis",
    loggedBy: "Logged by Nursing staff",
    badgeType: "purple",
    type: "Nursing Check",
  },
  {
    id: 4,
    time: "06:00 am",
    category: "WOUND / INCISION CHECK",
    description: "Incision clean and dry",
    loggedBy: "Logged by Nursing staff",
    badgeType: "purple",
    type: "Nursing Check",
  },
];

export const mentationOptions = [
  "BAR — Bright, Alert, Responsive",
  "Dull",
  "Depression",
  "Stuporous",
  "Comatose",
];

export const hydrationOptions = [
  "Normal",
  "Mild dehydration (~5%)",
  "Moderate dehydration (7-8%)",
  "Severe dehydration (10-12%)",
];

export const logTypeOptions = [
  { name: "Intake", value: "Intake" },
  { name: "Output", value: "Output" },
  { name: "Nursing Check", value: "Nursing Check" },
];

export const intakeCategoryOptions = [
  { name: "IV Fluid", value: "IV Fluid" },
  { name: "Oral Water", value: "Oral Water" },
  { name: "Food", value: "Food" },
  { name: "Blood / Blood Products", value: "Blood / Blood Products" },
];

export const outputCategoryOptions = [
  { name: "Urine", value: "Urine" },
  { name: "Vomiting", value: "Vomiting" },
  { name: "Feces", value: "Feces" },
  { name: "Blood Loss / Hemorrhage", value: "Blood Loss / Hemorrhage" },
  {
    name: "Other (wound drainage, discharge, etc.)",
    value: "Other (wound drainage, discharge, etc.)",
  },
];

export const nursingCategoryOptions = [
  { name: "IV Catheter / Site Check", value: "IV Catheter / Site Check" },
  { name: "Wound / Incision Check", value: "Wound / Incision Check" },
  { name: "Pressure Area Check", value: "Pressure Area Check" },
  { name: "Other Nursing Note", value: "Other Nursing Note" },
];

export const bloodProductTypeOptions = [
  { name: "Whole Blood", value: "Whole Blood" },
  { name: "Packed RBC", value: "Packed RBC" },
  { name: "Plasma", value: "Plasma" },
  { name: "Platelets", value: "Platelets" },
];

export const fecalScoreOptions = [
  { name: "1 — Very hard, dry", value: "1 — Very hard, dry" },
  { name: "2 — Firm, dry", value: "2 — Firm, dry" },
  {
    name: "3 — Firm, moist, holds shape",
    value: "3 — Firm, moist, holds shape",
  },
  { name: "4 — Soft, leaves residue", value: "4 — Soft, leaves residue" },
  { name: "5 — Soft, no shape", value: "5 — Soft, no shape" },
  { name: "6 — Watery", value: "6 — Watery" },
  { name: "7 — Watery with mucus/blood", value: "7 — Watery with mucus/blood" },
];

export const nursingFindingByCategory = {
  "IV Catheter / Site Check": [
    { name: "Patent, no issues", value: "Patent, no issues" },
    { name: "Mild swelling", value: "Mild swelling" },
    { name: "Phlebitis / Redness", value: "Phlebitis / Redness" },
    { name: "Dislodged / Removed", value: "Dislodged / Removed" },
  ],
  "Wound / Incision Check": [
    { name: "Clean, dry, healing well", value: "Clean, dry, healing well" },
    { name: "Discharge noted", value: "Discharge noted" },
    { name: "Redness / Swelling", value: "Redness / Swelling" },
    { name: "Dehiscence", value: "Dehiscence" },
  ],
  "Pressure Area Check": [
    {
      name: "No pressure sores, bedding adequate",
      value: "No pressure sores, bedding adequate",
    },
    { name: "Mild erythema", value: "Mild erythema" },
    { name: "Pressure sore noted", value: "Pressure sore noted" },
  ],
};

export const nursingFindingOptions = [
  "Patent, no issues",
  "Mild swelling",
  "Phlebitis / Redness",
  "Dislodged / Removed",
  "Incision clean and dry",
  "Discharge noted",
];
